import React, { Fragment } from "react";
import { Parallax } from "react-parallax";
import clgImg from "../../../assets/college-2.jpeg"
import Footer from "./HomePageFooter";
import HomePageHeader from "./HomePageHeader";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Typography } from "@mui/material";

const HomePage = () => {

    const renderWelcome = () => {
        return (
            <Parallax
                bgImage={clgImg}
                strength={400}
                bgImageAlt="College"
                bgImageStyle={{
                    objectFit: 'cover'
                }
                }
            >
                <section id="welcome">
                    <div className="overlay">
                        <div className="home-container">
                            <div className="row">
                                <div className="col-md-1"></div>
                                <div className="col-md-10 wow fadeIn" data-wow-delay="0.3s">
                                    <h1 className="text-upper">Welcome to St. Andrew's College</h1>
                                    <p>Accrediated by International Accreditation Organization (IAO). College has been awarded as CPE (Colleges with Potential for Excellence)</p>
                                    <p>Accorded "Star College" by Ministry of Science and Technology DBT, New Delhi</p>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                        </div>
                    </div>
                </section>
            </Parallax>
        );
    };

    const renderContactUs = () => {
        return (
            <section id="contact">
                <div className="overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                <h2 className="text-uppercase">Contact Us</h2>
                                <address>
                                    <p><i className="fa fa-map-marker"></i>St. Andrew's College, Civil Court Road, Gorakhpur - 273001 Uttar Pradesh (India)</p>
                                    <p><i className="fa fa-phone"></i> +91-551-2332172 | 2333917</p>
                                    <p><i className="fa fa-envelope-o"></i> principal@st-andrews-college.org</p>
                                    <p><i className="fa fa-fax"></i> +91-551-2332172 (in office Hrs. only)</p>
                                </address>
                            </div>
                            <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                <div className="contact-form">
                                    <h2 className="text-uppercase">Get in Touch</h2>
                                    <form action="#" method="post">
                                        <div className="col-md-6 col-sm-12">
                                            <input type="text" className="form-control" placeholder="Name" />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <input type="email" className="form-control" placeholder="Email" />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <input type="text" className="form-control" placeholder="Mobile" />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <input type="text" className="form-control" placeholder="City" />
                                        </div>
                                        <div className="col-md-12">
                                            <input type="text" className="form-control" placeholder="Address" />
                                        </div>
                                        <div className="col-md-12">
                                            <textarea className="form-control" placeholder="Subject" rows="4"></textarea>
                                        </div>
                                        <div className="col-md-8">
                                            <input type="submit" className="form-control text-uppercase" value="Send" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    const renderPrincipalSection = () => {
        return (
            <div className="principal">
                <div className="container pt-5 pb-3">
                    <div className="row">
                        <div className="pr-heading">
                            <h1>
                                Principal Message
                            </h1>
                        </div>
                    </div>
                    <div className="row pr-content">
                        <p>
                            St. Andrew’s College, Gorakhpur, named after Saint Andrew, one of the first twelve disciples of Jesus Christ, had a humble beginning in 1828 as a Mission School by the Church Missionary society to provide education primarily to Christian children but also to others irrespective of creed that voluntarily joined it.
                        </p>
                        <p>
                            The foundation of the Church Missionary Society (C.M.S.) in 1699 was consequential to the Evangelical Revival, with the role of great grandfather of Indian Evangelical Revival being ably played by the Rev. Charles Simeon. He was the Fellow of King's College and the Vicar of the Holy Trinity College, Cambridge.
                        </p>
                        <p>
                            Even while the Church was on the verge of becoming just a salutary maxim and devoid of consciousness of missionary obligations, he went about with his fiery zeal for the missionary enterprise in India. During the last decade of the 18th century, Rev.
                            Charles had the rare opportunity of influencing young potential zealots of the University towards a revival of missionary zeal.
                        </p>
                        <p>
                            Despite opposition by East India Company in direct missionary works in North India, he vented the innermost desires of his spiritual sons by making them chaplains of East India Company. Initially in the first half of the 19th century, the C.M.S. founded schools to provide education to Christian children of Indian and European descent.
                            Later the need was felt to mold them on theological ramparts and thereafter prepare them to attain ministry.
                        </p>
                        <p>
                            The maxim gradually became. And the 1857 mutiny struck a heavy blow to the institutions of higher education, which survived nevertheless by the end of century, especially during the tenure of Lord Curzon. It was in 1899, when a new impetus was given to the moribund state of development of Anglican Communion colleges in India.
                            Many colleges were established all across the country and as a result of it the missionaries got a fresh lease of life.
                            The names of some of these are Bishop's College, Calcutta, St. John's College, Agra, St. Paul's Cathedral College, Calcutta, St. Stephen's College, Delhi, Christ Church College, Kanpur, St. Andrew's College, Gorakhpur, St. Columbus College, Hazaribagh, Oxford and Cambridge Hostel, Allahabad, C.M.S. College, Kottayam, St. Paul's College, Palamcottah, Bishop Heber College, Trichinopoly, Nobel College, Maulipatam and Sarah Tucker College, Tamil Nadu.
                        </p>
                        <h5 className="mt-3">
                            Bishop's College, Calcutta:
                        </h5>
                        <p>
                            Established on 15th December, 1820, it is a leading Theological College of the Church of North India (CNI) providing and producing distinguished Church leaders for the CNI.
                        </p>
                        <h5 className="w-100">
                            St. John'sCollege, Agra:
                        </h5>
                        <p>
                            Established in the year 1885, it is a postgraduate institution with facilities of Arts, Science and Commerce.
                        </p>
                        <h5 className="w-100">
                            St. Paul's Cathedral College, Calcutta (1865):
                        </h5>
                        <p>
                            Established in 1865, it provides degree courses in Arts affiliated to the Calcutta University.
                        </p>
                        <h5 className="w-100">
                            St. Stephen's College, Delhi(1882):
                        </h5>
                        <p>
                            Established in 1882, it is one of the pioneering institutes of India.
                        </p>
                        <h5 className="w-100">
                            Christ Church College, Kanpur:
                        </h5>
                        <p>
                            It is a postgraduate academic institution Ewing Christian College, Allahabad It is another leading institution providing degree courses.
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    /* Later: Convert this to generic function during API integration */

    const renderNewsandEvents = () => {
        return (
            <section id="news" className="event-news">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="d-flex justify-content-between align-items-center" style={{ paddingRight: "40px" }}>
                                <h2>Notice & Alerts</h2>
                                <p className="m-0" style={{ cursor: "pointer" }}>View All<i className="fa fa-angle-right ml-2" aria-hidden="true"></i></p>
                            </div>
                            <div className="event-container">
                                <div className="event">
                                    <i className="fa fa-calendar mb-2" aria-hidden="true"></i> 23 Mar 2023
                                    <p>St. Andrews College is now the skill hub of NIELIT</p>
                                </div>
                                <div className="event">
                                    <i className="fa fa-calendar mb-2" aria-hidden="true"></i> 23 Mar 2023
                                    <p>St. Andrews College is now the skill hub of NIELIT</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="d-flex justify-content-between align-items-center" style={{ paddingRight: "40px" }}>
                                <h2>Events & Seminars</h2>
                                <p className="m-0" style={{ cursor: "pointer" }}>View All<i className="fa fa-angle-right ml-2" aria-hidden="true"></i></p>
                            </div>
                            <div className="event-container">
                                <div className="event">
                                    <i className="fa fa-calendar mb-2" aria-hidden="true"></i> 23 Mar 2023
                                    <p>St. Andrews College is organising a new inter-college sports festival. All the students are requested to take part in different sports.</p>
                                </div>
                                <div className="event">
                                    <i className="fa fa-calendar mb-2" aria-hidden="true"></i> 23 Mar 2023
                                    <p>St. Andrews College is organising a new inter-college sports festival. All the students are requested to take part in different sports.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    const itemData = [
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/1828164753001 048.jpg',
            title: 'Women Cell Programme',
            featured: true,
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/1826978509001 031.jpg',
            title: 'Republic Day 2016',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/678780219DSC_0034.JPG',
            title: 'Rajyapal Visit',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/2084195417001 065.jpg',
            title: 'Fashion Designing',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/1298439573DSC_0804.jpg',
            title: 'Computer Sc. Deptt. Inspection by NIELIT',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/982854433DSC_0478.jpg',
            title: 'Christmas 2015',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/506095675DSC_0019.JPG',
            title: 'Rover/Ranger Closing Camp ',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/2022196207DSC_0226.JPG',
            title: 'St. Andrews College IGNOU Centre Inauguration',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/18495684821.JPG',
            title: 'St- Andrews Legal Aid Clinic Inauguration on 19-10-2013',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/825749583DSC06303.JPG',
            title: 'St. Andrew College ',
        },
        {
            img: 'https://www.st-andrews-college.org/download/gallery/category/1700742494slider-1.jpg',
            title: 'St. Andrew College ',
        }
    ];

    const renderGallerySection = () => {
        return (
            <section id="gallery">
                <div className="container">
                    <h2>Gallery</h2>
                    <div className="event-container">
                        <ImageList sx={{ width: "auto", height: "auto" }} cols={6} gap={4}>
                            {itemData.map((item) => (
                                <ImageListItem key={item.img} style={{
                                    height: "fit-content",
                                    // width: "15vw"
                                    cursor: "pointer"
                                }}>
                                    <img
                                        src={`${item.img}`}
                                        srcSet={`${item.img}`}
                                        alt={item.title}
                                        loading="lazy"
                                    // width={120}
                                    // height={120}
                                    />
                                    <ImageListItemBar
                                        title=""
                                        subtitle={
                                            <Typography variant="subtitle1" component="div" sx={{
                                                whiteSpace: "break-spaces",
                                                // backgroundColor: "#cecece54"
                                            }}>
                                                {item.title}
                                            </Typography>
                                        }
                                        position="below"
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </div>
                </div>
            </section>
        );
    };

    return (
        <Fragment>
            <HomePageHeader isHome />
            {renderWelcome()}
            {renderPrincipalSection()}
            {renderNewsandEvents()}
            {renderGallerySection()}
            {renderContactUs()}
            <Footer />
        </Fragment>
    )
}

export default HomePage;